import React, { useEffect, useState } from "react";
import Frame from "components/shared/Frame";
import { IStep } from "types";
import Button from "components/shared/Button";
import { Form, Formik } from "formik";

import * as Yup from "yup";
import loader from "assets/loader.gif";
import axios from "axios";

import AppInput from "components/shared/AppInput";
import { toast } from "react-toastify";
import { api } from "../../../../constants";

const OtpStep: React.FC<IStep> = ({
  onBack,
  onNext,
  value,
  step,
  parent,
}: any) => {
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");

  // Sent OTP

  function onOTPVerify() {
    setLoading(true);
    (window as any).confirmationResult
      .confirm(otp)
      .then(async (res: any) => {
        toast.success("Phone Number verified successfully!");
        if (!parent) {
        } else {
          onNext();
        }
      })
      .catch((err: any) => {
        console.log(err);
        toast.error(err.message);
        onBack();
      });
  }

  const validationSchema = Yup.object().shape({
    otp: Yup.string()
      .min(6, "OTP should be 6 characters long")
      .max(6, "OTP should be 6 characters long")
      .required("OTP is required"),
  });

  return (
    <Frame
      step={step}
      title="Enter The OTP to Verify Your Mobile Number"
      onBackButtonClick={onBack}
    >
      <Formik
        initialValues={{ otp: "" }}
        validationSchema={validationSchema}
        onSubmit={onOTPVerify}
      >
        {({ handleSubmit, isSubmitting, errors, touched }) => (
          <Form>
            <div className="row">
              <div className="col-12">
                <AppInput
                  name="otp"
                  value={otp}
                  placeholder="Enter OTP"
                  onChange={(e) => setOtp(e.target.value)}
                />
              </div>
            </div>

            <div className="btn__submit">
              <div className="row">
                <div className="col-12">
                  <Button
                    value="Submit"
                    onClick={() => {
                      onOTPVerify();
                    }}
                  />
                </div>
              </div>
            </div>

            {isSubmitting && (
              <img
                src={loader}
                style={{ width: 300, margin: "auto" }}
                alt="loader"
              />
            )}
          </Form>
        )}
      </Formik>
    </Frame>
  );
};

export default OtpStep;
